import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import EmailField from '@/components/forms/new/formikFormFields/EmailField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../../walkthroughIds';

const AdminUsersEmail = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.email && touched.email}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Email <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>{' '}
                    <Text sx={descriptionStyling} maxWidth={250}>
                        If enabling SSO, please ensure the Admin Email address
                        is configured on a supported domain.
                    </Text>
                </Box>
                <Field
                    component={EmailField}
                    id="email"
                    name="email"
                    type="email"
                    walkthroughid={walkthroughIds.adminsGeneral.ufEmail}
                    validate={(value) => {
                        if (!value) {
                            return 'Please provide an email address';
                        }
                        if (
                            !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                                value,
                            )
                        ) {
                            return 'Please provide a valid email address';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Provide unique email address for the Admin User"
                        ariaLabel="admin-user-email-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AdminUsersEmail;
